<template>
  <div>
    <el-select
      v-model="localValue"
      :multiple="multiple"
      :clearable="clearable"
      :filterable="filterable"
      :class="`required-value-${id}`"
      class="select-primary custom-width-select required-lots shadow-sm"
      size="large"
      :placeholder="$t('common_words.select')"
    >
      <el-option
        v-for="item in items"
        :value="objects ? item.id : item"
        :label="objects ? item.name : item"
        :key="objects ? item.id : item"
        class="select-primary"
      ></el-option>
    </el-select>
    <p v-show="showError" class="mt-2 text-muted text-danger">
      {{ messageError }}
    </p>
  </div>
</template>
<script>
import mixinVModel from 'src/util/mixinVModel';

export default {
  name: 'SelectableCapture',
  props: {
    items: {
      type: Array,
      required: true,
    },
    objects: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    filterable: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [mixinVModel],
};
</script>
